/** Risk / preference group on allocation sell reasons (e.g. CATEGORY_NOT_RECOMMENDED). */
export enum LumpsumAllocationRiskGroup {
  HIGH_RISK = 'HIGH_RISK',
  MEDIUM_RISK = 'MEDIUM_RISK',
  LOW_RISK = 'LOW_RISK',
  SILVER_AND_GOLD = 'SILVER_AND_GOLD',
  GLOBAL_US = 'GLOBAL_US',
  HYBRID = 'HYBRID',
  DEBT = 'DEBT',
  SECTORAL = 'SECTORAL',
  INDEX = 'INDEX',
  GLOBAL_NON_CORE = 'GLOBAL_NON_CORE',
  DEBT_AND_ARBITRAGE = 'DEBT_AND_ARBITRAGE',
  RETIREMENT = 'RETIREMENT',
  CHILDREN = 'CHILDREN',
  NEW_INVESTMENT = 'NEW_INVESTMENT',
  EMERGENCY = 'EMERGENCY',
  OTHER = 'OTHER'
}

const LUMPSUM_ALLOCATION_RISK_GROUP_LABELS: Record<LumpsumAllocationRiskGroup, string> = {
  [LumpsumAllocationRiskGroup.HIGH_RISK]: 'High Risk',
  [LumpsumAllocationRiskGroup.MEDIUM_RISK]: 'Medium Risk',
  [LumpsumAllocationRiskGroup.LOW_RISK]: 'Low Risk',
  [LumpsumAllocationRiskGroup.SILVER_AND_GOLD]: 'Gold & Silver',
  [LumpsumAllocationRiskGroup.GLOBAL_US]: 'Global US',
  [LumpsumAllocationRiskGroup.HYBRID]: 'Hybrid',
  [LumpsumAllocationRiskGroup.DEBT]: 'Debt',
  [LumpsumAllocationRiskGroup.SECTORAL]: 'Sectoral',
  [LumpsumAllocationRiskGroup.INDEX]: 'Index',
  [LumpsumAllocationRiskGroup.GLOBAL_NON_CORE]: 'Global Non Core',
  [LumpsumAllocationRiskGroup.DEBT_AND_ARBITRAGE]: 'Debt & Arbitrage',
  [LumpsumAllocationRiskGroup.RETIREMENT]: 'Retirement',
  [LumpsumAllocationRiskGroup.CHILDREN]: 'Children',
  [LumpsumAllocationRiskGroup.NEW_INVESTMENT]: 'New Investment',
  [LumpsumAllocationRiskGroup.EMERGENCY]: 'Emergency',
  [LumpsumAllocationRiskGroup.OTHER]: 'Other'
}

export function formatRiskGroupLabel(riskGroup?: string | null): string {
  if (riskGroup == null || riskGroup.trim().length === 0) {
    return ''
  }
  const normalizedRiskGroup = riskGroup.trim().toUpperCase()
  if (normalizedRiskGroup in LUMPSUM_ALLOCATION_RISK_GROUP_LABELS) {
    return LUMPSUM_ALLOCATION_RISK_GROUP_LABELS[normalizedRiskGroup as LumpsumAllocationRiskGroup]
  }
  return riskGroup.trim()
}
